import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchFamilies(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/families', {params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        fetchFamily(ctx, { id }) {
            return new  Promise((resolve, reject) => {
                axios
                    .get(`/families/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        addFamily(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/families', data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        deleteFamily(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/families/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        updateFamily(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/families/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error)) 
            })
        },

    }
}